// @mui material components

// Argon Dashboard 2 MUI components
import Button from "themeComponents/Button";
import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";

// Argon Dashboard 2 MUI context
import { useArgonController } from "context";

// Images
import icon from "assets/images/illustrations/icon-documentation.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DeleteAlert } from "components/swalAlert";
import { logout } from "slices/authSlice";

function SidenavFooter() {
  const [controller] = useArgonController();
  const { miniSidenav, darkSidenav } = controller;
  const navigator = useNavigate();
  const dispatch = useDispatch();
  return (
    <Box opacity={miniSidenav ? 0 : 1} sx={{ transition: "opacity 200ms linear" }}>
      <Box position="relative" textAlign="center">
        <Box component="img" src={icon} alt="sidebar_illustration" width="60%" />
        <Box
          width="100%"
          pb={2}
          px={2}
          color={darkSidenav ? "white" : "dark"}
          textAlign="center"
          lineHeight={0}
        >
          <Typography color="inherit" variant="h6">
            Need help?
          </Typography>
          <Typography
            onClick={() => navigator("/tickets")}
            color="inherit"
            variant="caption"
            sx={{
              color: "#1A73E8",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Open a support ticket
          </Typography>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column">
        <Button
          onClick={async () => {
            if (!(await DeleteAlert("You want to sign out."))) return;
            dispatch(logout());
            navigator("/authentication/sign-in");
          }}
          color="info"
          size="small"
          fullWidth
          mb={2}
        >
          Sign Out
        </Button>
      </Box>
    </Box>
  );
}

export default SidenavFooter;
